const paletteGGT = {
  primary: {
    dark: "#00261F",
    main: "#134C45",
    light: "#39726B"
  },
  custom: {
    secondary: "#0EB1A0"
  }
};

export default paletteGGT;
